module.exports = __webpack_public_path__ + "img/icon-room-study.3649ae08.svg";